import * as types from './actionTypes';
import instrumentService from '../services/instrumentService';
import { fetch, addTask } from 'domain-task';

export function getInstruments() {
    return (dispatch, getState) => {
        const instruments = getState().instruments;
        if(instruments.length == 0) {        
            let fetchTask = instrumentService.getInstruments()
                .then(instruments => {
                    if(instruments) {
                        dispatch({ type: types.GET_INSTRUMENTS, instruments });
                    }
                    return instruments;
                })
                .catch(error => {
                    throw(error);
                });
            addTask(fetchTask);
        }
    };
}